import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import DateInputShowComponent from "./DateInputShowComponent"
import CustomHeader from "../DateRangePicker/CustomHeader"
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useIntl } from "react-intl";
import { Icon, IconButton } from '@mui/material';

//Styles
import './customDateRangePicker.scss';

const CustomDateRangePicker = React.forwardRef((props) => {
    const { messages } = useIntl();
    const lang = useSelector(state => state.commonRedux.language);
    const [dateRange, setDateRange] = useState(props.dateRange || [null, null])
    const [startDate, setStartDate] = useState(props.dateRange[0] || null)
    const [endDate, setEndDate] = useState(props.dateRange[1] || null)
    const ref = React.createRef();

    const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => {
        return (
            <>
                <DateInputShowComponent
                    id="date-picker"
                    placeholder={value || props.placeholder || "Select Date Range"}
                    onClick={onClick}
                    width={props.inputWidth}
                    ref={ref}
                />
            </>
        )
    })

    useEffect(() => {
        if (dateRange[0]) {
            setStartDate(dateRange[0])
        } else {
            setStartDate(undefined)
        }

        if (dateRange[1]) {

            setEndDate(dateRange[1])
        } else {
            setEndDate(undefined)
        }
    }, [dateRange])
    return (
        <DatePicker
            // Date range selecting enabled
            selectsRange={true}
            startDate={props.dateRange[0]}
            endDate={props.dateRange[1]}
            onChange={update => {
                setDateRange(update)
                props.onChange && props.onChange(update[0], update[1])
            }}
            minDate={props.minDate}
            maxDate={props.maxDate}
            // Starts from Monday
            calendarStartDay={1}
            locale={lang}
            customInput={
                <CustomDateInput value={props.placeholder} onClick={props.onClick} ref={ref} />
            }
            renderCustomHeader={props => {
                return (
                    <CustomHeader
                        date={props.date}
                        changeYear={props.changeYear}
                        changeMonth={props.changeMonth}
                        decreaseMonth={props.decreaseMonth}
                        increaseMonth={props.increaseMonth}
                        messages={messages}
                    />
                )
            }}
            props
            portalId="root-portal"
        />
    )
})

export default CustomDateRangePicker
